import { Message, MessageBox } from 'element-ui';

// 防止重复弹出登录过期提示的标志
let isLoginExpiredShowing = false;

/**
 * 处理登录过期
 * 统一入口，同时控制 Message 提示和 MessageBox 确认对话框，防止并发请求导致重复弹出
 */
export function handleLoginExpired() {
  if (isLoginExpiredShowing) return;
  isLoginExpiredShowing = true;

  // 弹出错误消息提示（仅一次）
  Message({
    message: '登录已过期，请重新登录',
    type: 'error',
    duration: 2000
  });

  // 弹出确认对话框
  MessageBox.confirm('您的登录状态已失效，请重新登录', '提示', {
    confirmButtonText: '前往',
    cancelButtonText: '取消',
    type: 'warning',
    closeOnClickModal: false,
    closeOnPressEscape: false,
    showClose: false
  }).then(() => {
    // 点击前往 - 清除 token 并跳转登录页
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('username');
    window.location.href = '/login';
  }).catch(() => {
    // 点击取消 - 停留在当前页面，重置标志以便后续可再次提示
    isLoginExpiredShowing = false;
  });
}
